var _g, _path, _path2, _path3, _path4, _g2, _g3, _g4, _rect, _rect2, _g5, _rect3, _g6, _g7, _g8, _path5, _path6, _path7, _path8, _g9, _g10, _g11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpvote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2136_65138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.20081 3.86869C9.20081 2.50653 10.3051 1.40228 11.6672 1.40228C13.0294 1.40228 14.1336 2.50653 14.1336 3.86869V6.70703C14.1336 6.94909 14.1168 7.19044 14.0794 7.43172C14.0658 7.51981 14.0521 7.60781 14.0436 7.6957C14.0167 7.97356 14.0496 8.33646 14.2384 8.58017L13.7874 9.01523C16.0488 10.1706 17.5984 12.5332 17.5984 15.26C17.5984 15.9987 17.4847 16.7107 17.2739 17.3793L16.5265 22.2591H10.4504V22.257C6.69802 22.1763 3.6875 19.7293 3.6875 15.26C3.6875 12.6327 4.94548 10.5177 6.84863 9.32515L6.84392 9.32138C6.97356 9.2313 7.12644 9.13964 7.29037 9.04136L7.29156 9.04064C7.83131 8.71708 8.49096 8.32162 8.83904 7.67489C9.14079 7.1142 9.19939 6.20419 9.19939 5.78231L9.20081 5.78296V3.86869Z",
    fill: "url(#paint0_linear_2136_65138)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20081 3.86869C9.20081 2.50653 10.3051 1.40228 11.6672 1.40228C13.0294 1.40228 14.1336 2.50653 14.1336 3.86869V6.70703C14.1336 6.94909 14.1168 7.19044 14.0794 7.43172C14.0658 7.51981 14.0521 7.60781 14.0436 7.6957C14.0167 7.97356 14.0496 8.33646 14.2384 8.58017L13.7874 9.01523C16.0488 10.1706 17.5984 12.5332 17.5984 15.26C17.5984 15.9987 17.4847 16.7107 17.2739 17.3793L16.5265 22.2591H10.4504V22.257C6.69802 22.1763 3.6875 19.7293 3.6875 15.26C3.6875 12.6327 4.94548 10.5177 6.84863 9.32515L6.84392 9.32138C6.97356 9.2313 7.12644 9.13964 7.29037 9.04136L7.29156 9.04064C7.83131 8.71708 8.49096 8.32162 8.83904 7.67489C9.14079 7.1142 9.19939 6.20419 9.19939 5.78231L9.20081 5.78296V3.86869Z",
    fill: "url(#paint1_radial_2136_65138)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20081 3.86869C9.20081 2.50653 10.3051 1.40228 11.6672 1.40228C13.0294 1.40228 14.1336 2.50653 14.1336 3.86869V6.70703C14.1336 6.94909 14.1168 7.19044 14.0794 7.43172C14.0658 7.51981 14.0521 7.60781 14.0436 7.6957C14.0167 7.97356 14.0496 8.33646 14.2384 8.58017L13.7874 9.01523C16.0488 10.1706 17.5984 12.5332 17.5984 15.26C17.5984 15.9987 17.4847 16.7107 17.2739 17.3793L16.5265 22.2591H10.4504V22.257C6.69802 22.1763 3.6875 19.7293 3.6875 15.26C3.6875 12.6327 4.94548 10.5177 6.84863 9.32515L6.84392 9.32138C6.97356 9.2313 7.12644 9.13964 7.29037 9.04136L7.29156 9.04064C7.83131 8.71708 8.49096 8.32162 8.83904 7.67489C9.14079 7.1142 9.19939 6.20419 9.19939 5.78231L9.20081 5.78296V3.86869Z",
    fill: "url(#paint2_radial_2136_65138)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20081 3.86869C9.20081 2.50653 10.3051 1.40228 11.6672 1.40228C13.0294 1.40228 14.1336 2.50653 14.1336 3.86869V6.70703C14.1336 6.94909 14.1168 7.19044 14.0794 7.43172C14.0658 7.51981 14.0521 7.60781 14.0436 7.6957C14.0167 7.97356 14.0496 8.33646 14.2384 8.58017L13.7874 9.01523C16.0488 10.1706 17.5984 12.5332 17.5984 15.26C17.5984 15.9987 17.4847 16.7107 17.2739 17.3793L16.5265 22.2591H10.4504V22.257C6.69802 22.1763 3.6875 19.7293 3.6875 15.26C3.6875 12.6327 4.94548 10.5177 6.84863 9.32515L6.84392 9.32138C6.97356 9.2313 7.12644 9.13964 7.29037 9.04136L7.29156 9.04064C7.83131 8.71708 8.49096 8.32162 8.83904 7.67489C9.14079 7.1142 9.19939 6.20419 9.19939 5.78231L9.20081 5.78296V3.86869Z",
    fill: "url(#paint3_radial_2136_65138)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20081 3.86869C9.20081 2.50653 10.3051 1.40228 11.6672 1.40228C13.0294 1.40228 14.1336 2.50653 14.1336 3.86869V6.70703C14.1336 6.94909 14.1168 7.19044 14.0794 7.43172C14.0658 7.51981 14.0521 7.60781 14.0436 7.6957C14.0167 7.97356 14.0496 8.33646 14.2384 8.58017L13.7874 9.01523C16.0488 10.1706 17.5984 12.5332 17.5984 15.26C17.5984 15.9987 17.4847 16.7107 17.2739 17.3793L16.5265 22.2591H10.4504V22.257C6.69802 22.1763 3.6875 19.7293 3.6875 15.26C3.6875 12.6327 4.94548 10.5177 6.84863 9.32515L6.84392 9.32138C6.97356 9.2313 7.12644 9.13964 7.29037 9.04136L7.29156 9.04064C7.83131 8.71708 8.49096 8.32162 8.83904 7.67489C9.14079 7.1142 9.19939 6.20419 9.19939 5.78231L9.20081 5.78296V3.86869Z",
    fill: "url(#paint4_linear_2136_65138)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2136_65138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7592 11.0316C17.7592 9.97457 16.9023 9.11771 15.8454 9.11771H13.7255C12.6685 9.11771 11.8116 9.97457 11.8116 11.0316C11.8116 11.621 12.0781 12.1482 12.4971 12.4993C12.0339 12.8498 11.7344 13.4062 11.7344 14.0311C11.7344 14.6162 11.9969 15.1412 12.4106 15.4935C11.9969 15.8445 11.7344 16.3683 11.7344 16.9534V17.0478C11.7344 17.5722 11.9453 18.0473 12.2869 18.393C11.9457 18.7305 11.7344 19.199 11.7344 19.7169C11.7344 20.7454 12.5682 21.5792 13.5967 21.5792H15.6994C16.728 21.5792 17.5618 20.7454 17.5618 19.7169C17.5618 19.3764 17.4704 19.0573 17.3109 18.7827C17.9635 18.4779 18.4157 17.8156 18.4157 17.0478V16.9534C18.4157 16.3612 18.1468 15.8318 17.7243 15.4807C18.1295 15.1286 18.3857 14.6091 18.3857 14.0311C18.3857 13.2644 17.9349 12.6007 17.2838 12.294C17.5798 11.9571 17.7592 11.5153 17.7592 11.0316Z",
    fill: "url(#paint5_linear_2136_65138)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_2136_65138)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.4675,
    y: 8.04788,
    width: 4.36515,
    height: 6.78263,
    rx: 2.18258,
    transform: "rotate(90 19.4675 8.04788)",
    fill: "url(#paint6_linear_2136_65138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.4675,
    y: 8.04788,
    width: 4.36515,
    height: 6.78263,
    rx: 2.18258,
    transform: "rotate(90 19.4675 8.04788)",
    fill: "url(#paint7_radial_2136_65138)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_2136_65138)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.2424,
    y: 18.0114,
    width: 4.2477,
    height: 6.64565,
    rx: 2.12385,
    transform: "rotate(90 19.2424 18.0114)",
    fill: "url(#paint8_linear_2136_65138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.2424,
    y: 18.0114,
    width: 4.2477,
    height: 6.64565,
    rx: 2.12385,
    transform: "rotate(90 19.2424 18.0114)",
    fill: "url(#paint9_radial_2136_65138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.2424,
    y: 18.0114,
    width: 4.2477,
    height: 6.64565,
    rx: 2.12385,
    transform: "rotate(90 19.2424 18.0114)",
    fill: "url(#paint10_radial_2136_65138)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.2424,
    y: 18.0114,
    width: 4.2477,
    height: 6.64565,
    rx: 2.12385,
    transform: "rotate(90 19.2424 18.0114)",
    fill: "url(#paint11_linear_2136_65138)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2424,
    y: 18.0114,
    width: 4.2477,
    height: 6.64565,
    rx: 2.12385,
    transform: "rotate(90 19.2424 18.0114)",
    fill: "url(#paint12_radial_2136_65138)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2136_65138)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.7161,
    y: 19.274,
    width: 4.02769,
    height: 1.10715,
    rx: 0.553575,
    fill: "url(#paint13_linear_2136_65138)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2163,
    y: 14.8011,
    width: 4.47282,
    height: 7.61949,
    rx: 2.23641,
    transform: "rotate(90 20.2163 14.8011)",
    fill: "#C4C4C4",
    fillOpacity: 0.66
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_2136_65138)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.2163,
    y: 14.8011,
    width: 4.47282,
    height: 7.61949,
    rx: 2.23641,
    transform: "rotate(90 20.2163 14.8011)",
    fill: "url(#paint14_linear_2136_65138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.2163,
    y: 14.8011,
    width: 4.47282,
    height: 7.61949,
    rx: 2.23641,
    transform: "rotate(90 20.2163 14.8011)",
    fill: "url(#paint15_radial_2136_65138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.2163,
    y: 14.8011,
    width: 4.47282,
    height: 7.61949,
    rx: 2.23641,
    transform: "rotate(90 20.2163 14.8011)",
    fill: "url(#paint16_radial_2136_65138)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_2136_65138)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.4238,
    y: 16.3714,
    width: 5.04364,
    height: 1.10715,
    rx: 0.553575,
    fill: "url(#paint17_linear_2136_65138)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_2136_65138)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1821,
    y: 11.4637,
    width: 4.37494,
    height: 7.58522,
    rx: 2.18747,
    transform: "rotate(90 20.1821 11.4637)",
    fill: "url(#paint18_linear_2136_65138)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1821,
    y: 11.4637,
    width: 4.37494,
    height: 7.58522,
    rx: 2.18747,
    transform: "rotate(90 20.1821 11.4637)",
    fill: "url(#paint19_radial_2136_65138)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 1.40228C10.3049 1.40228 9.20064 2.50653 9.20064 3.86869V5.78296L9.19922 5.78231C9.19922 6.20419 9.14062 7.1142 8.83887 7.67489C8.49078 8.32164 7.83115 8.71707 7.2914 9.04064C7.12701 9.1392 6.97371 9.23108 6.84375 9.32138C7.58986 9.91903 9.11778 11.1132 9.15527 11.085C9.19276 11.0569 10.9131 10.1436 11.7686 9.69052L11.7322 9.17259C13.0642 9.13805 14.1335 8.04741 14.1335 6.70703V3.86869C14.1335 2.50653 13.0292 1.40228 11.667 1.40228Z",
    fill: "url(#paint20_radial_2136_65138)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 1.40228C10.3049 1.40228 9.20064 2.50653 9.20064 3.86869V5.78296L9.19922 5.78231C9.19922 6.20419 9.14062 7.1142 8.83887 7.67489C8.49078 8.32164 7.83115 8.71707 7.2914 9.04064C7.12701 9.1392 6.97371 9.23108 6.84375 9.32138C7.58986 9.91903 9.11778 11.1132 9.15527 11.085C9.19276 11.0569 10.9131 10.1436 11.7686 9.69052L11.7322 9.17259C13.0642 9.13805 14.1335 8.04741 14.1335 6.70703V3.86869C14.1335 2.50653 13.0292 1.40228 11.667 1.40228Z",
    fill: "url(#paint21_radial_2136_65138)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1067 1.95853C9.55367 2.41082 9.20068 3.09854 9.20068 3.86869V4.01279H10.3155C10.3194 3.86435 10.312 3.48428 10.251 3.15146L10.2384 3.08292C10.1767 2.74764 10.1059 2.36324 10.1067 1.95853Z",
    fill: "#FFBF71"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1067 1.95853C9.55367 2.41082 9.20068 3.09854 9.20068 3.86869V4.01279H10.3155C10.3194 3.86435 10.312 3.48428 10.251 3.15146L10.2384 3.08292C10.1767 2.74764 10.1059 2.36324 10.1067 1.95853Z",
    fill: "url(#paint22_radial_2136_65138)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_2136_65138)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.1421,
    y: 8.64343,
    width: 4.60176,
    height: 1.88666,
    rx: 0.94333,
    fill: "url(#paint23_linear_2136_65138)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_2136_65138)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.0886,
    y: 12,
    width: 5.37904,
    height: 1.88666,
    rx: 0.94333,
    fill: "url(#paint24_linear_2136_65138)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_2136_65138)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.3628,
    y: 2.33432,
    width: 2.14893,
    height: 5.99805,
    rx: 1.07446,
    fill: "url(#paint25_linear_2136_65138)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2136_65138",
    x: 3.6875,
    y: 1.40228,
    width: 14.4109,
    height: 20.8568,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.847059 0 0 0 0 0.458824 0 0 0 0 0.360784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2136_65138"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2136_65138",
    x: 9.73438,
    y: 7.11771,
    width: 10.6814,
    height: 16.4615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2136_65138"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_2136_65138",
    x: 12.6848,
    y: 8.04788,
    width: 7.28271,
    height: 4.36516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.541176 0 0 0 0 0.0627451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2136_65138"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_2136_65138",
    x: 12.5967,
    y: 17.5114,
    width: 7.14575,
    height: 4.7477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.941176 0 0 0 0 0.643137 0 0 0 0 0.215686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2136_65138"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2136_65138",
    x: 13.4661,
    y: 18.024,
    width: 6.52759,
    height: 3.60715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_2136_65138"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_2136_65138",
    x: 12.5969,
    y: 14.3011,
    width: 8.11938,
    height: 4.97282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.941176 0 0 0 0 0.643137 0 0 0 0 0.215686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2136_65138"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_2136_65138",
    x: 13.1738,
    y: 15.1214,
    width: 7.5437,
    height: 3.60715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_2136_65138"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_2136_65138",
    x: 12.5969,
    y: 10.9637,
    width: 8.08521,
    height: 4.87494,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.941176 0 0 0 0 0.643137 0 0 0 0 0.215686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2136_65138"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_2136_65138",
    x: 12.8921,
    y: 7.39343,
    width: 7.10181,
    height: 4.38666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_2136_65138"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_2136_65138",
    x: 12.8386,
    y: 10.75,
    width: 7.87915,
    height: 4.38666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_2136_65138"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_2136_65138",
    x: 10.1128,
    y: 1.08432,
    width: 4.64893,
    height: 8.49805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_2136_65138"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2136_65138",
    x1: 14.4406,
    y1: 4.97958,
    x2: 6.89372,
    y2: 20.8702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A528"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2136_65138",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3301 3.63312) rotate(141.116) scale(3.76173 11.1026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE34C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2136_65138",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.4819 11.8307) rotate(125.191) scale(5.57266 4.03692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA2E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2136_65138",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5272 13.5984) rotate(146.743) scale(12.143 21.2507)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.681103,
    stopColor: "#E18E3F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E18E3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2136_65138",
    x1: 10.643,
    y1: 19.1714,
    x2: 10.643,
    y2: 22.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8796F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8796F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2136_65138",
    x1: 15.0751,
    y1: 9.11771,
    x2: 15.0751,
    y2: 19.0837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1730B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E27D47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2136_65138",
    x1: 21.6501,
    y1: 8.04788,
    x2: 21.6501,
    y2: 14.8305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A928"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2136_65138",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.5848 13.7273) rotate(127.367) scale(1.74083 1.16526)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D98320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D98320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2136_65138",
    x1: 21.3663,
    y1: 18.5936,
    x2: 21.3663,
    y2: 24.6571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A928"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2136_65138",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.4901 23.3108) rotate(-90) scale(5.4851 2.08666)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29545",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2136_65138",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9881 23.5741) rotate(-90) scale(5.56268 1.49322)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA810B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB610",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2136_65138",
    x1: 23.928,
    y1: 21.3342,
    x2: 22.5539,
    y2: 21.3342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC7C6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC7C6A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2136_65138",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.3663 25.5367) rotate(-90) scale(4.20243 6.31702)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E38811",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2136_65138",
    x1: 18.5345,
    y1: 19.5775,
    x2: 14.193,
    y2: 19.5775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF166",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2136_65138",
    x1: 22.4527,
    y1: 15.4687,
    x2: 22.4527,
    y2: 22.4206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A928"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2136_65138",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6891 20.8771) rotate(-90) scale(6.28888 2.19725)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29545",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2136_65138",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0015 21.179) rotate(-90) scale(6.37782 1.57236)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA810B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB610",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2136_65138",
    x1: 19.2055,
    y1: 16.675,
    x2: 13.7688,
    y2: 16.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF166",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2136_65138",
    x1: 22.3696,
    y1: 11.4637,
    x2: 22.3696,
    y2: 19.0489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A928"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2136_65138",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0281 17.4802) rotate(-90) scale(4.12551 1.83635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29545",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2136_65138",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.40269 3.63312) rotate(90) scale(4.7701 1.77108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3A52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3A52A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2136_65138",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.00944 6.77383) rotate(42.9975) scale(2.38925 3.61534)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDA25E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDA25E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2136_65138",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.489 3.33795) rotate(-168.366) scale(1.22959 2.68387)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.549892,
    stopColor: "#CCB28B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCB28B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2136_65138",
    x1: 18.5048,
    y1: 9.16074,
    x2: 13.5445,
    y2: 9.16074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF166",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2136_65138",
    x1: 19.1882,
    y1: 12.5173,
    x2: 13.39,
    y2: 12.5173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF166",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2136_65138",
    x1: 13.4001,
    y1: 3.97893,
    x2: 11.0837,
    y2: 3.97893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF166",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpvote);
export default __webpack_public_path__ + "static/media/upvote.4ad60f24.svg";
export { ForwardRef as ReactComponent };